document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector(".wp-block-klingit-basic-header");

    const stickyHeader = document.querySelector("header .is-position-sticky");

    if (stickyHeader) {
        window.scrollDirectionDown = true;
        let momentFromScrollDown = 0;
        let momentFromScrollUp = 0;
        let oldScroll = 0;

        if (window.scrollY > 10) {
            stickyHeader.classList.add("sticky");
        }

        window.addEventListener('scroll', () => {
            if (oldScroll > this.scrollY) {
                if (momentFromScrollDown === 0) {
                    momentFromScrollDown = this.scrollY;
                }
                if ((momentFromScrollDown - 50) > this.scrollY) {
                    window.scrollDirectionDown = false;
                }
                momentFromScrollUp = 0;
            } else {
                if (momentFromScrollUp === 0) {
                    momentFromScrollUp = this.scrollY;
                }
                if ((momentFromScrollUp + 10) < this.scrollY) {
                    window.scrollDirectionDown = true;
                }
                momentFromScrollDown = 0;
            }

            if (window.scrollDirectionDown && window.scrollY > 10) {
                stickyHeader.classList.add("sticky");
            } else {
                stickyHeader.classList.remove("sticky");
            }

            if (oldScroll === -1 && window.scrollY === 0) {
                stickyHeader.classList.remove("sticky");
            }

            oldScroll = this.scrollY;
        });
    }

    if (header) {
        const overlay = document.querySelector(".overlay");
        const menu = header.querySelector(".menu-container .menu-inner");

        if (menu) {
            const headerButton = header.querySelector(".menu-button");
            
            headerButton.addEventListener("click", () => {
                document.querySelector("html").classList.toggle("is-menu-active");
            });

            overlay.addEventListener("click", () => {
                document.querySelector("html").classList.remove("is-menu-active");
            });

            const menuElements = header.querySelectorAll(".wp-block-klingit-basic-container > .wp-block-group > *:not(.wp-block-klingit-basic-logo, .wp-block-site-logo, .wp-block-spacer, .wp-block-klingit-basic-submenu > *, .wp-block-klingit-basic-submenu .wp-block-klingit-basic-link, .wp-block-klingit-basic-submenu .wp-block-buttons), .wp-block-klingit-basic-container > .wp-block-columns > .wp-block-column > .wp-block-group > *:not(.wp-block-klingit-basic-logo, .wp-block-site-logo, .wp-block-spacer, .wp-block-klingit-basic-submenu > *, .wp-block-klingit-basic-submenu .wp-block-klingit-basic-link, .wp-block-klingit-basic-submenu .wp-block-buttons)");

            const ctaButtons = header.querySelector(".wp-block-klingit-basic-container > .wp-block-group > .wp-block-buttons");

            menuElements.forEach(element => {
                menu.appendChild(element.cloneNode(true));

                if (element.classList.contains("wp-block-klingit-basic-link") && element.hasAttribute("data-submenu")) {
                    const submenuMobile = document.createElement("div");
                    submenuMobile.classList.add("submenu-container");
                    
                    const submenuMobileInner = document.createElement("div");
                    submenuMobileInner.classList.add("menu-inner");

                    const submenuId = element.getAttribute("data-submenu");
                    const submenu = header.querySelector(`.wp-block-klingit-basic-submenu[data-submenu=${submenuId}]`);

                    const mobileSubmenu = submenu.querySelector("*").cloneNode(true);
                    submenuMobile.setAttribute("mobile-submenu", submenuId);

                    mobileSubmenu.querySelectorAll(".accordion-block, .wp-block-klingit-basic-scroller, .timeline-block").forEach(notSupported => {
                        notSupported.remove();
                    });

                    if (mobileSubmenu.querySelectorAll(".wp-block-klingit-basic-tabs").length > 0) {
                        mobileSubmenu.querySelectorAll(".wp-block-klingit-basic-tabs").forEach(menuTabs => {
                            const tabs = menuTabs;
                            const layout = tabs.classList.contains("tabs-vertical") ? "vertical" : "horizontal";
                            const tabContents = tabs.querySelectorAll(".wp-block-klingit-basic-tab");
        
                            if (layout === "vertical") {
                                const buttons = tabs.querySelectorAll("button[data-button]");
                                const navButtons = tabs.querySelectorAll(".tabs-navigation button[data-button]");
                                navButtons[0].classList.add("is-active");
        
                                buttons.forEach(button => {
                                    button.addEventListener("click", () => {
                                        const id = button.getAttribute("data-button");
        
                                        tabContents.forEach((tabContent, i) => {
                                            const content = tabContent.querySelector(".tab-content");
        
                                            if (content.getAttribute("data-tab") === id) {
                                                tabContent.classList.add("is-visible");
                                                navButtons[i].classList.add("is-active");
                                            } else {
                                                tabContent.classList.remove("is-visible");
                                                navButtons[i].classList.remove("is-active");
                                            }
                                        });
                                    });
                                });
                            }
        
                            if (layout === "horizontal") {
                                const tabContents = tabs.querySelectorAll(".wp-block-klingit-basic-tab");
                                tabContents.forEach((tabContent, i) => {
                                    tabContent.classList.add("splide__slide");
                                });
        
                                const desktopNavigation = document.createElement("div");
                                desktopNavigation.classList.add("tabs-navigation");
        
                                tabContents.forEach((tabContent, i) => {
                                    const button = tabContent.querySelector("button");
        
                                    if (i == 0) {
                                        tabContent.classList.add("is-visible");
                                    }
                                    desktopNavigation.appendChild(button.cloneNode(true));
                                });
        
                                tabs.prepend(desktopNavigation);
        
                                const navButtons = tabs.querySelectorAll(".tabs-navigation button[data-button]");
                                navButtons[0].classList.add("is-active");
        
                                const splide = new Splide(tabs.querySelector(".tabs-content"), {
                                    pagination: false,
                                    arrows: false
                                });
        
                                splide.on('moved', (newIndex, prevIndex) => {
                                    navButtons[newIndex].classList.add("is-active");
                                    navButtons[newIndex].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
                                    navButtons[prevIndex].classList.remove("is-active");
                                });
        
                                splide.mount();
        
                                navButtons.forEach((button, i) => {
                                    button.addEventListener("click", () => {
                                        navButtons.forEach(compareButton => {
                                            if (button !== compareButton) {
                                                compareButton.classList.remove("is-active");
                                            }
                                        });
        
                                        button.classList.add("is-active");
                                        splide.go(i);
                                    });
                                });
                            }
                        });
                    }

                    submenuMobileInner.appendChild(mobileSubmenu);

                    if (ctaButtons) {
                        submenuMobileInner.appendChild(ctaButtons.cloneNode(true));
                    }

                    submenuMobile.appendChild(submenuMobileInner);

                    header.querySelector(".menu-container").parentNode.appendChild(submenuMobile);
                }
            });
        }

        // dropdown

        const dropdownLinks = header.querySelectorAll(".wp-block-klingit-basic-link[data-submenu]:not(.menu-container .wp-block-klingit-basic-link)");
        const menuDropdownLinks = header.querySelectorAll(".menu-container .wp-block-klingit-basic-link[data-submenu]");

        function renderSubmenu(link, submenu, device) {
            const isMegaMenu = submenu.classList.contains("mega-menu");
            const linkRect = link.getBoundingClientRect();
            let submenuRect = submenu.getBoundingClientRect();

            if (isMegaMenu) {
                const windowWidth = window.innerWidth;
                let cornerLeft = 0;
                let cornerRight = 0;

                if (windowWidth >= 1440) {
                    cornerLeft = submenuRect.width / 2;
                    cornerRight = 1240 - submenuRect.width / 2;
                } else if (windowWidth >= 1366) {
                    cornerLeft = submenuRect.width / 2;
                    cornerRight = 1120 - submenuRect.width / 2;
                } else if (windowWidth >= 1024) {
                    cornerLeft = submenuRect.width / 2;
                    cornerRight = Math.min(1005, windowWidth - 60) - submenuRect.width / 2 - 15;
                }

                submenu.style.top = `calc(${linkRect.top + linkRect.height - header.getBoundingClientRect().top + 48}px)`;
                submenu.style.left = `max(${cornerLeft}px, min(${linkRect.left + linkRect.width / 2}px, ${cornerRight}px))`;

                submenuRect = submenu.getBoundingClientRect();

                submenu.style.setProperty('--header-chevron-x-position', linkRect.left - submenuRect.left + linkRect.width / 2 - 26 + "px");
            }

            submenuRect = submenu.getBoundingClientRect();

            if (device === "mouse") {
                const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                svg.classList.add("mouse-area");
                const path = document.createElementNS(
                    'http://www.w3.org/2000/svg',
                    'path'
                );

                svg.setAttribute('fill', 'red');
                const width = window.innerWidth;
                const height = submenuRect.bottom - linkRect.top;
                svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
                svg.style.width = width;
                svg.style.height = height + 4;
                svg.style.top = `calc(${linkRect.top - header.getBoundingClientRect().top}px - 2px)`;
                svg.style.left = (header.querySelector(".wp-block-klingit-basic-container").getBoundingClientRect().width - width) / 2;

                path.setAttribute(
                    'd',
                    `M${linkRect.left} 0 
                L ${linkRect.right} 0 
                Q ${linkRect.right + Math.abs(linkRect.right - submenuRect.right) / 20} ${(submenuRect.top - linkRect.top + 6)}
                    ${submenuRect.right} ${submenuRect.top - linkRect.top + 6} 
                L ${submenuRect.left} ${submenuRect.top - linkRect.top + 6}
                Q ${linkRect.left - Math.abs(linkRect.left - submenuRect.left) / 20} ${(submenuRect.top - linkRect.top + 6)}
                    ${linkRect.left} 0 `
                );

                svg.appendChild(path);

                return svg;
            }
        }

        dropdownLinks.forEach(link => {
            const submenuId = link.getAttribute("data-submenu");
            const submenus = header.querySelectorAll(`.wp-block-klingit-basic-submenu[data-submenu]:not(.menu-container .wp-block-klingit-basic-submenu)`);
            const submenu = header.querySelector(`.wp-block-klingit-basic-submenu[data-submenu=${submenuId}]:not(.menu-container .wp-block-klingit-basic-submenu)`);

            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                link.addEventListener("click", () => {
                    if (submenu.classList.contains("is-visible")) {
                        submenu.classList.remove("is-visible");
                        link.classList.remove("is-open");
                    } else {
                        renderSubmenu(link, submenu, 'touch');
                        submenus.forEach((compareSubmenu, i) => {
                            if (submenu !== compareSubmenu) {
                                compareSubmenu.classList.remove("is-visible");
                                dropdownLinks[i].classList.remove("is-open");
                            }
                        });
                        submenu.classList.add("is-visible");
                        link.classList.add("is-open");
                    }
                });

                document.addEventListener("click", (e) => {
                    if (!submenu.contains(e.target) && !link.contains(e.target)) {
                        submenu.classList.remove("is-visible");
                        link.classList.remove("is-open");
                    }
                });

                window.addEventListener("scroll", () => {
                    submenu.classList.remove("is-visible");
                    link.classList.remove("is-open");
                });
            } else {
                link.addEventListener("mouseenter", () => {
                    let svg;

                    if (!link.querySelector("svg.mouse-area")) {
                        svg = renderSubmenu(link, submenu, 'mouse');
                        link.append(svg);
                    }
                    submenu.classList.add("is-visible");
                    link.classList.add("is-open");

                    const area = link.querySelector("svg.mouse-area path");
                    if (svg) {
                        area.addEventListener("mouseleave", (e) => {
                            if (!submenu.contains(e.toElement)) {
                                submenu.classList.remove("is-visible");
                                link.classList.remove("is-open");

                                svg.remove();
                            }
                        });

                        submenu.addEventListener("mouseleave", (e) => {
                            if (!area.contains(e.toElement)) {
                                submenu.classList.remove("is-visible");
                                link.classList.remove("is-open");
                                svg.remove();
                            }
                        });
                    }
                });
            }
        });

        menuDropdownLinks.forEach(link => {
            link.addEventListener("click", () => {
                const submenuId = link.getAttribute("data-submenu");
                const submenu = header.querySelector(`.submenu-container[mobile-submenu=${submenuId}]`);

                if (link.classList.contains("is-open")) {
                    header.classList.remove("is-submenu-mobile-visible");
                    submenu.classList.remove("is-visible");

                    link.classList.remove("is-open");
                } else {
                    header.classList.add("is-submenu-mobile-visible");
                    submenu.classList.add("is-visible");

                    link.classList.add("is-open");
                }
            });
        });

        const slideBackButton = header.querySelector(".menu-back-button");

        slideBackButton.addEventListener("click", () => {
            const submenu = header.querySelector(`.submenu-container.is-visible`);
            const link = header.querySelector(`.menu-container .wp-block-klingit-basic-link.is-open`);

            header.classList.remove("is-submenu-mobile-visible");
            submenu.classList.remove("is-visible");

            link.classList.remove("is-open");
        });
    }
});